module.exports = __webpack_public_path__ + "img/15.ad88e18e.png";